import './Navbar.css';
import logo from '../../assets/icons/logo.png';
import React from 'react';

const Navbar: React.FC = () => {
  return (
    <nav className="navbar">
      <div className="nav-inner">
        <a href="/" className="nav-brand">
          <img src={logo} alt="Sermyble" />
        </a>
        <div className="nav-right">
          <a href="tel:+917093281075" className="nav-phone">
            <span className="phone-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg></span>
            <span className="phone-text">+91 70932 81075</span>
          </a>
          <a href="/status" className="nav-status">Check Status</a>
          <a href="https://seller.sermyble.com" target="_blank" rel="noopener noreferrer" className="nav-cta">
            Seller Login
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
